import axios from 'axios';

/**
 * Función para obtener información del producto por ID
 * @param {Object} {domain:(string), currency:'MXN|USD', type:'', typeDomainRegister:'register|transfer|renew', productId:(number) }
 * @param {AbortController.signal} typeDomain 
 * @returns 
 */
const getDomainPrices = async ({domain, currency, type, typeDomainRegister = 'register', productId = 0}, signal) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await axios.post(apiUrl, new URLSearchParams({
      type: 'getPriceDomain',
      domain: domain,
      currency: currency,
      typeDomain: type,
      type_domain_register: typeDomainRegister,
      product_id: productId,
      responsetype: 'json',
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', 
        // 'X-Requested-With': 'XMLHttpRequest'
      },
      signal
    });
 
    return response.data;
  } catch (error) {
    // que sea un error diferente a la cancelacion de signal
    if (error.name !== 'CanceledError') {
      console.error('Error fetching product info:', error);
      throw error;
    }
  }
};

export default getDomainPrices;
